import { number as cardNumberValidator } from '@ott/utility-card-validator';
import { removeNonNumbers } from '@ott/transforms';
import { isOldWebkit } from '@ott/utility-formatters';

const TEST_IS_NUMBER = /\d/;

const ccNumberFormatter = function (value = '', previous = '', cursor = 0, props) {
  let gaps = [4, 8, 12];
  let length = 19;
  let result = '';
  let resultCursor = cursor;

  const { card } = cardNumberValidator(removeNonNumbers(value));

  if (card) {
    length = card.lengths.pop() || 19;

    if (card.type === 'visa' && length > 16) {
      gaps = [4, 8, 12, 16];
    } else if (card.gaps.length) {
      gaps = card.gaps;
    }
  }

  let gap = gaps.shift();

  for (let i = 0, j = 0; i < value.length && j < length; i++) {
    const c = value.charAt(i);

    if (TEST_IS_NUMBER.test(c)) {
      result += c;
      ++j;
    } else {
      if (i < cursor) {
        --resultCursor;
      }
    }

    if (j === gap) {
      gap = gaps.shift();
      result += ' ';
      if (i < cursor) {
        ++resultCursor;
      }
    }
  }

  return {
    value: result,
    cursor: resultCursor,
  };
};

export default isOldWebkit ? removeNonNumbers : ccNumberFormatter;
